import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {WorkforceProfileAnalysisDataInputSection} from '../WorkforceProfileDetail/WorkforceProfileAnalysisDataInputSection';

import {InfoBanner} from '../../../../../components/InfoBanner/InfoBanner';
import type {WorkforceProfileAnalysisDataInput} from '../../types/workforceProfileDetailsTypes';
import type {WorkforceProfileGuidedStepId} from '../../types/workforceProfileWizardTypes';
import {GUIDED_WIZARD_STEP_ORDER} from '../../types/workforceProfileWizardTypes';

export interface Props {
  analysisInput: WorkforceProfileAnalysisDataInput;
  reviewIssues: string[];
  onEditStep: (stepId: WorkforceProfileGuidedStepId) => void;
}

export const WorkforceProfileWizardReviewStep = ({analysisInput, reviewIssues, onEditStep}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.review'});

  const missingSectionLabels = reviewIssues
    .map((issue) => t(`issues.${issue}`, {defaultValue: issue}))
    .join(', ');

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      {reviewIssues.length > 0 && (
        <Typography variant='body2' color='error' sx={{mb: 2}}>
          {t('missingSections', {sections: missingSectionLabels})}
        </Typography>
      )}
      <WorkforceProfileAnalysisDataInputSection data={analysisInput} alwaysExpanded />
      <Box sx={{mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1}}>
        {GUIDED_WIZARD_STEP_ORDER.filter((stepId) => !['research', 'review'].includes(stepId)).map((stepId) => (
          <Typography
            key={stepId}
            component='button'
            type='button'
            variant='body2'
            onClick={() => onEditStep(stepId)}
            sx={{
              border: 'none',
              background: 'none',
              color: 'primary.main',
              cursor: 'pointer',
              p: 0,
              textDecoration: 'underline',
            }}
          >
            {t('editStep', {step: t(`stepLabels.${stepId}`)})}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
